import { axios } from "@Root/API";

export const getContacts = (params, contactType) => {
  const url = contactType ? `contacts/type/${contactType}` : "contacts";
  return axios.get(url, {
    params
  });
};
